export var ThirdPartyType;
(function (ThirdPartyType) {
    ThirdPartyType["Consultant"] = "consultant";
    ThirdPartyType["ManagedService"] = "managed_service";
    ThirdPartyType["Outsource"] = "outsource";
    ThirdPartyType["Partner"] = "partner";
    ThirdPartyType["Supplier"] = "supplier";
})(ThirdPartyType || (ThirdPartyType = {}));
//# sourceMappingURL=third-party-type.js.map